import { BodyMassIndex } from './BodyMassIndex.js';
import { SCALAR_MEASUREMENTS } from './scalarMeasurements.js';
/**
 * Every measurement the observation pipeline ingests or derives, keyed by kind. The single source of
 * truth: {@link MeasurementKind} is derived from these keys, so a kind cannot exist without a definition.
 * The patient-reportable subset lives in {@link SCALAR_MEASUREMENTS}; derived-only kinds (BMI) are added
 * here. Blood pressure is intentionally absent — it is not ingested (see {@link BloodPressure}).
 */
export const MEASUREMENTS = {
    ...SCALAR_MEASUREMENTS,
    BODY_MASS_INDEX: BodyMassIndex,
};
//# sourceMappingURL=measurements.js.map